import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callGetSpecialAgentCommisionById, callUploadFile } from "../../api/settings/service";
import { callAddRequestNotification } from "../../api/notifications/service"
import CopyrightFooter from "../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../components/header/DashboardHeader";
import BackPrevious from "../../components/back-previous";
import DashboardEmployerSidebar from "../../components/header/DashboardSidebar";
import MobileMenu from "../../components/header/MobileMenu";
import { handleInput, displayUrl } from "../../utils/commonUtil";
import { toast } from "react-toastify";
import "../../components/i18n/lang";
import { decodeBase64, handleGetCookie } from "../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import colors from '../../utils/colors'
import notiTypeList from "../../data/notificationType"
import * as XLSX from 'xlsx';
import "../style.css"
import FileUploadGrid from "../../components/upload-file";
import SmartTable from "../../components/common/table-component";

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [selectedFile, setSelectedFile] = useState(null);
	const [selectedImport, setSelectedImport] = useState(null);
	const [notification, setNotification] = useState({
		id: null,
		title: '',
		body: '',
		notiType: '8',
		description: '',
		carriredCode: '',
		carriredName: '',
		documentPath: null,
		importPath: null,
		isFocus: false,
		lstUser: [],
	});
	const tableRef = useRef(null);
	const fileInputRef = useRef(null);
	const importFileRef = useRef(null);
	let params = useParams();

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				getSepcialAgentCommissionById(id)
			}
		}
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setNotification((prev) => ({
				...prev,
				carriredName: authData?.user?.firstName,
				carriredCode: authData?.user?.userId,
			}));
		}
	}, []);

	const getSepcialAgentCommissionById = async (id) => {
		try {
			const rsp = await dispatch(callGetSpecialAgentCommisionById({ id }));
			if (rsp?.payload?.responseCode === "00000") {
				const item = rsp?.payload?.data
				console.log(item)
				setNotification((prev) => ({
					...prev,
					id: id,
					title: item.title,
					body: item.body,
					notiType: item.notiType,
					description: item.description,
					documentPath: item.documentPath
				}));
			}


		} catch (error) {
			console.error(error)
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setNotification({
			...notification,
			[name]: value,
		});
	};

	const handleSave = async (e) => {
		e.preventDefault()
		if (notification.lstUser <= 0 && notification.notiType != 8) {
			Swal.fire(__t("uiText.text308"), __t("uiText.text310"), "warning");
			return
		}
		Swal.fire({
			title: t("titleSave"),
			text: t("confirmSave"),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {

					let docPath = null
					if (selectedFile !== null) {
						let upload = await dispatch(callUploadFile(selectedFile.file));
						if (upload?.payload?.responseCode === "00000") {
							docPath = upload?.payload?.data.map((item) => `${process.env.REACT_APP_SERVER_URL}/view/display${item}`)
						}
					}
					const phoneNumbers = notification.lstUser.map(row => row[1]);
					let req = {
						title: notification.title,
						description: notification.description,
						carriredCode: notification.carriredCode,
						carriredName: notification.carriredName,
						body: notification.body,
						notiType: notification.notiType,
						lstUser: phoneNumbers,
						imgPath: docPath[0],
					}

					const res = await dispatch(callAddRequestNotification(req));
					if (res?.payload?.responseCode === "00000") {
						Swal.fire({
							icon: "success",
							title: t("success.add"),
							confirmButtonColor: colors.confirmMessage,
							confirmButtonText: t('close'),
						}).then(function () {
							notifyListRefresh();
							navigate(-1);
						});
					} else {
						toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
							position: "top-left"
						})
					}
				} catch (error) {
					Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
				}
			}
		});
	}

	const triggerFileInput = () => {
		fileInputRef.current.click();
	};

	const handleImageSelect = (e) => {
		console.log(e)
		if (e) {
			setSelectedFile({ file: e });

			// }
			// e.target.value = '';
		}
	}

	const cancelSeletedFile = () => {
		setSelectedFile(null);
		if (notification.documentPath !== null) {
			setNotification((prev) => ({
				...prev,
				documentPath: null,
			}));
		}
	};

	const importFileInput = () => {
		importFileRef.current.click();
	};

	const handleImportSelect = (e) => {
		const file = e.target.files[0];
		if (file) {
			const imageUrl = URL.createObjectURL(file);
			setSelectedImport({ file, url: imageUrl });
		}
		e.target.value = '';
	};

	const cancelSeletedImport = () => {
		setSelectedImport(null);
		setNotification((prev) => ({
			...prev,
			importPath: null,
			lstUser: []
		}));
	};

	const importUserList = (e) => {
		e.preventDefault();

		const reader = new FileReader();
		reader.onload = (evt) => {
			const binaryStr = evt.target.result;
			const workbook = XLSX.read(binaryStr, { type: 'binary' });

			const sheetName = workbook.SheetNames[0];
			const sheet = workbook.Sheets[sheetName];
			const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

			const filtered = jsonData.filter((row, index) => {
				return index !== 0 && row[1] && row[1].toString().trim() !== '';
			});
			console.log(filtered)
			setNotification((prev) => ({
				...prev,
				lstUser: filtered,
			}));
		};

		reader.readAsBinaryString(selectedImport?.file);
	}

	const handleDeleteRow = (indexToRemove) => {
		setNotification((prev) => ({
			...prev,
			lstUser: prev.lstUser.filter((_, index) => index !== indexToRemove)
		}));

		setTimeout(() => {
			tableRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
		}, 100);
	};

	const selectNotiType = (e) => {
		setNotification((prev) => ({
			...prev,
			notiType: e.target.value
		}));
	}

	const renderImportUser = () => {
		return (
			<div className="ls-widget">
				<div className="tabs-box">
					<div className="widget-content p-4">
						<div className="default-form">
							<div className="row">
								<div className="col-12">
									<h6>{t('notification.userList')}</h6>
								</div>
							</div>
							<SmartTable
	tableRef={tableRef}
	columns={[
		{ labelKey: "notification.user.id", key: 0 },
		{ labelKey: "notification.user.phone", key: 1 },
		{ labelKey: "notification.user.name", key: 2 },
	]}
	data={{ result: notification.lstUser }}
	rowKey="0"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={true}
	actions={(item, index) => (
		<button className="btn btn-danger btn-sm" onClick={() => handleDeleteRow(index)}>
			<i className="fas fa-trash"></i>
		</button>
	)}
/>
						</div>
					</div>
				</div>
			</div>
		)
	}

	const renderRequest = () => {
		return (
			<div className="ls-widget">
				<div className="tabs-box">
					<div className="widget-content p-4">
						<div className="default-form">
							<div className="row">
								<div className="col-md-4 form-group">
									<label> {t('notification.title')} <span className="text-danger">*</span> </label>
									<input
										type="text"
										name="title"
										className="form-control-uld"
										placeholder={t('notification.title')}
										onInput={handleInput}
										onChange={handleChange}
										value={notification.title}
										autoComplete="off"
										required />
								</div>

								<div className="col-md-3 form-group">
									<label> {t('notification.notiType')} <span className="text-danger">*</span> </label>
									<select className="chosen-single form-select"
										onChange={selectNotiType}
										value={notification.notiType}
										required>
										{
											notiTypeList.map((item) => (
												<option key={item.id} value={item.id}>{t(item.name)}</option>
											))
										}
									</select>
								</div>

								<div className="col-md-5 form-group">
									<label> {t('notification.description')} <span className="text-danger">*</span> </label>
									<input
										type="text"
										name="description"
										className="form-control-uld"
										placeholder={t('notification.description')}
										onInput={handleInput}
										onChange={handleChange}
										value={notification.description}
										autoComplete="off" />
								</div>

								<div className="col-md-12 form-group">
									<label> {t('notification.body')}<span className="text-danger">*</span> </label>
									<textarea
										name="body"
										placeholder={t('notification.body')}
										value={notification.body}
										onChange={handleChange}
										required>
									</textarea>
								</div>

								<div className={`col-12 form-group col-md ${notification.notiType != 8 ? "-6" : "-12"}`} >
									<label> {t('notification.image')}</label>
									<FileUploadGrid
										multiple={false}
										folderName="notifications"
										// filesFromApi={filesFromApi}
										onChange={handleImageSelect}
										accept="image/*"
									/>
								</div>

								{
									notification.notiType != 8 ?
										<div className="col-12 col-md-6 form-group">
											<label> {t('notification.userList')} <span className="text-danger">*</span> </label>
											{
												selectedImport !== null || notification.importPath !== null ? (
													<div className="d-flex justify-content-center align-items-center flex-column text-center" style={{ height: "296px", }}>
														<div className="image-preview-box w-100">
															<label>{selectedImport?.url || notification.importPath}</label>
															<div className="action-buttons d-flex flex-row gap-2">
																<button type="button" className="btn btn-danger" onClick={cancelSeletedImport}>{t("cancel")}</button>
																<button type="button" className="btn btn-success" onClick={importUserList}>{t("button.import")}</button>
															</div>
														</div>
													</div>
												) :
													<div className="image-box upload-box w-100" onClick={importFileInput}>
														<i className="fas fa-file-excel camera-size"></i>
													</div>
											}
											<input
												type="file"
												accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
												ref={importFileRef}
												style={{ display: 'none' }}
												onChange={handleImportSelect}
											/>
										</div> : null
								}


								<div className="col-12 d-flex justify-content-center">
									<div className="m-3">
										<button className="theme-btn btn-style-one w-100" type="submit">
											<i className="fas fa-add"></i>&nbsp;{t("button.save")}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	const handleDownloadTemplate = (e) => {
		e.preventDefault();
		const link = document.createElement('a');
		link.href = process.env.REACT_APP_SERVER_URL + '/view/display/templates/templates.xlsx';
		link.download = 'templates.xlsx';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box">
							<div className="upper-title-box back-title-group">
								<BackPrevious />
								<h4>{t("notification.name")}</h4>
							</div>

							<div className="group-button-header">
								<button className="btn btn-success text-white" onClick={handleDownloadTemplate}>
									<i className="fas fa-file-excel"></i> {t("notification.template")}
								</button>
							</div>
						</div>

						{renderRequest()}

						{notification.lstUser.length > 0 ? renderImportUser() : null}
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
